import { makeAutoObservable, observable } from "mobx"
import { makeContext } from "utils/provider"
import Content from "./content"
import Project from "./project"
import Scheme from "./schema"

class MainStore {

  selectedProject: string | null = null
  projects = observable.map<string, Project>([])
  schemes = observable.map<string, Scheme>([])
  
  constructor() {
    const data = require('assets/mocks/demo.json')
    const schema = new Scheme(data.id)
    schema.data = data
    this.schemes.set(schema.id, schema)

    const data2 = require('assets/mocks/curriculum.json')
    const schema2 = new Scheme(data2.id)
    schema2.data = data2
    this.schemes.set(schema2.id, schema2)

    makeAutoObservable(this)  
  }

  init() {
    const projectIds = JSON.parse(window.localStorage.getItem("projects") || "[]")
    const schemeIds = JSON.parse(window.localStorage.getItem("schemes") || "[]")

    for (let schemeId of schemeIds) {
      const schemeData = JSON.parse(window.localStorage.getItem(schemeId) || "null")
      if (!schemeData) continue
      const scheme = new Scheme(schemeId)
      scheme.setData(schemeData)
      this.schemes.set(scheme.id, scheme)
    }

    for (let projectId of projectIds) {
      const projectData = JSON.parse(window.localStorage.getItem(projectId) || "null")
      if (!projectData) continue

      const project = new Project(projectData.id)
      project.name = projectData.name
      project.slug = projectData.slug
      this.projects.set(project.id, project)

      for (let contentId of projectData.contentIds) {
        const contentData = JSON.parse(window.localStorage.getItem(contentId) || "null")
        if (!contentData) continue

        const content = new Content(contentData.schemeId, contentId)
        content.name = contentData.name
        content.ignoreBlocks = contentData.ignoreBlocks
        content.data = contentData.data
        project.contents.set(content.id, content)
      }
    }
  }

  selectProject(projectId: typeof this.selectedProject) {
    this.selectedProject = projectId
  }

  addProject(project: Project) {
    this.projects.set(project.id, project)
    this.saveProject(project)
  }

  addScheme(scheme: Scheme) {
    this.schemes.set(scheme.id, scheme)
    this.saveSchema(scheme)
  }

  getContentsWithScheme(schemeId: string) {
    let contents = []
    for (let project of this.projects.values()) {
      for (let content of project.contents.values()) {
        if (content.schemeId === schemeId) {
          contents.push(content)
        }
      }
    }
    return contents
  }

  deleteSchema(schemeId: string) {
    this.schemes.delete(schemeId)
    this.saveSchemes()
  }

  deleteProject(projectId: string) {
    if (this.selectedProject === projectId) {
      this.selectProject(null)
    }
    this.projects.delete(projectId)
    this.saveProjects()
  }

  saveContent(content: Content) {
    window.localStorage.setItem(content.id, JSON.stringify(content.save()))
  }
  saveProject(project: Project) {
    window.localStorage.setItem(project.id, JSON.stringify(project.saveInfo()))
    this.saveProjects()
  }
  saveProjects() {
    window.localStorage.setItem("projects", JSON.stringify(Array.from(this.projects.keys())))
  }
  saveSchema(schema: Scheme) {
    window.localStorage.setItem(schema.id, JSON.stringify(schema.data))
    this.saveSchemes()
  }
  saveSchemes() {
    window.localStorage.setItem("schemes", JSON.stringify(Array.from(this.schemes.keys())))
  }
}

export default MainStore

const [ MainStoreProvider, useMainStore ] = makeContext(() => new MainStore())
export { MainStoreProvider, useMainStore, MainStore }